export enum ValidationMessageType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
}
